import { useContext } from 'react';
import { Context } from "../state/context";
import { CONFIG } from '../config';

/*
Extend fetch API to send authorization header
 */

export default function useFetch() {
	const { state } = useContext(Context);
	return (url, params) => {
		return fetch(CONFIG.apiBaseUrl + url, {
			...params,
			headers: { Authorization: `Bearer ${state.authKey}` },
		})
	};
}
